import React from "react";
import { useParams } from "react-router";
import { Segment } from "semantic-ui-react";
import config from "../../../../config";
import TwoWayCommunicationModal from "./TwoWayCommunicationModal";
import TwoWayCommunicationButton from "./TwoWayCommunicationButton";

interface TwoWayCommunicationSectionProps {
  classificationName: string;
  headline: string;
  classificationActive: boolean;
  modalOpen: boolean;
  closeModal: () => void;
  openModal: () => void;
}
export default function TwoWayCommunicationSection({
  classificationName,
  headline,
  classificationActive,
  modalOpen,
  openModal,
  closeModal,
}: TwoWayCommunicationSectionProps) {
  const { site } = useParams<{ site: string }>();
  const onClick = () => {
    if (classificationActive) {
      openModal();
    } else {
      window.location.href = `${config.GOGOV_WEB_URL}/${site}/support.php?cmd=shell`;
    }
  };

  return (
    <>
      <TwoWayCommunicationModal
        headline={headline}
        open={modalOpen}
        onClose={closeModal}
        classificationName={classificationName}
        classificationActive={classificationActive}
      />
      {!!classificationActive && (
        <Segment basic className='tw-justify-left tw-m-0 tw-mt-4 tw-flex tw-p-0'>
          <TwoWayCommunicationButton onClick={onClick} />
        </Segment>
      )}
    </>
  );
}
